import React, { useState, useEffect } from "react"
import { Link, NavLink, useHistory, useParams } from 'react-router-dom'
import { Alert, Button, Glyphicon } from 'react-bootstrap'
import axios from 'axios'


import getServerURL from "../../../../functions/getServerURL"
import LoadingAnimation from "../../../../reuseable-components/LoadingAnimation"
import Materials from "../Materials"
import QMSHelpFooter from "../QMSHelpFooter"
import "../style.css"


export default function SelectedTraining() {
    // REACT ROUTER DOM
    const params = useParams()
    const history = useHistory()

    // STATE
    const [loadingTraining, setLoadingTraining] = useState(true)
    const [selectedTraining, setSelectedTraining] = useState(null)
    const [knowledgeAssessment, setKnowledgeAssessment] = useState(null)

    // FUNCTIONS
    const getTraining = (id) => {
        // setLoadingTraining(true)
        axios.get(`${getServerURL()}trainings/${id}/get_training_and_assignment/`, {
            params: { is_published: true },
            headers: { "Authorization": `Bearer ${ localStorage.getItem("token") }` }
        }).then(response => {
            if (!selectedTraining) {
            setSelectedTraining(response.data.training)
            setKnowledgeAssessment(response.data.result)
            }
        }).catch(error => {
            if (error.response && error.response.status === 404) {
            history.replace("/trainings")
            }
        }).then(() => {
            setLoadingTraining(false)
        })
    }

    const renderSelectedTraining = () => {
        return (
            loadingTraining ?
                <LoadingAnimation />
                :
                <div>
                    <center>
                        <br />
                        <h2>{ selectedTraining && selectedTraining.name }</h2>
                    </center>
                    <br/>
                    <Materials selectedTraining={ selectedTraining } />
                    { knowledgeAssessment &&
                        <div>
                            { knowledgeAssessment.message ?
                                <Alert bsStyle="success">
                                    { knowledgeAssessment.message }
                                    <a style={{ float: "right" }} href={ knowledgeAssessment.certificate } target="_blank">View Certificate</a>
                                </Alert>
                                :
                                <Alert bsStyle={ knowledgeAssessment.status === "Not Taken" ? "info" : "danger" }>
                                    { knowledgeAssessment.status === "Not Taken" ?
                                        <p>The knowledge assessment has not been taken yet.</p>
                                        :
                                        <p>The knowledge assessment has been failed the last time it was taken. Please try again.</p>
                                    }
                                    <br/>
                                    <NavLink to={`/trainings/${selectedTraining.id}/assessment`}>
                                        <Button>Knowledge Assessment</Button>
                                    </NavLink>
                                </Alert>
                            }
                        </div>
                    }
                </div>
        )
    }
    
    useEffect(() => {
        getTraining(params.id)
    }, [])


    // RENDER
    return (
        <div>
            <div id="QMSTrainingContainer">
                { loadingTraining ?
                    <LoadingAnimation />
                    :
                    <div>
                        <div style={{ float:"left", position: "absolute" }}>
                            <Link to={ `/trainings/` }>
                                <Button className="back-button">
                                    <Glyphicon glyph="arrow-left" /> Back to Trainings
                                </Button>
                            </Link>
                        </div>
                        { renderSelectedTraining() }
                    </div>
                }
            </div>
            <br />
            <br />
            <br />
            <QMSHelpFooter/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/Trainings/SelectedTraining.js